import { CSSProperties, FC } from 'react';

export type Color = 'black' | 'gray' | 'white' | 'yellow' | 'blue' | 'emerald' | 'purple';

export const mapColorToCssColor: Record<Color, string> = {
  black: '#000',
  gray: '#A3A3A3',
  white: '#FFF',
  yellow: '#FACC15',
  blue: '#0EA5E9',
  emerald: '#34D399',
  purple: '#A855F7',
};

export interface IconProps {
  Source: FC;
  color?: Color;
  rawColor?: string;
  styles?: CSSProperties;
  className?: string;
}

export const Icon = ({ Source, className, rawColor, styles = {}, color = 'black' }: IconProps) => {
  return (
    <div style={{ color: rawColor || mapColorToCssColor[color], ...styles }} className={className}>
      <Source />
    </div>
  );
};
